import { BedDouble, ExternalLink } from "lucide-react";

/*
 * "Staying the night?" — hotels near the venue for the night of the show.
 * Both buttons are InstaPass affiliate links (Expedia Group Travel Creator Program):
 *   Hotels.com: the Creator Hub link-builder format (camref 1011l3H7RY)
 *   Expedia:    Partnerize camref 1101l3GWJ7 (same code as the Expedia banners and search widget)
 * Hotels.com resolves a venue name to the area around it (tested: "Crypto.com Arena, Los Angeles, CA").
 */
const HOTELS = { camref: "1011l3H7RY", creativeref: "1011l66481", adref: "PZAxBRHseq" };
const EXPEDIA_CAMREF = "1101l3GWJ7";

/** Night of the show and the morning after, from the event's local start (YYYY-MM-DD). */
export function stayDates(raw) {
  const local = String(raw?.occurs_at_local || raw?.occurs_at || "").slice(0, 10);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(local)) return null;
  const d = new Date(`${local}T12:00:00Z`);
  const today = new Date(); today.setUTCHours(0, 0, 0, 0);
  if (d < today) return null; // past events: no hotel card
  const out = new Date(d.getTime() + 86400000);
  return { checkIn: local, checkOut: out.toISOString().slice(0, 10) };
}

export function stayLinks(raw, adults = 2) {
  const v = raw?.venue || {};
  const where = [v.name || v.location, v.city, v.state].filter(Boolean).join(", ");
  const dates = stayDates(raw);
  if (!where || !dates) return null;
  const q = new URLSearchParams({ destination: where, startDate: dates.checkIn, endDate: dates.checkOut, adults: String(adults) });
  const hotelsSearch = `https://www.hotels.com/Hotel-Search?${q}`;
  const expediaSearch = `https://www.expedia.com/Hotel-Search?${q}`;
  return {
    where,
    venue: v.name || v.location || v.city,
    dates,
    hotels: `https://www.hotels.com/affiliate?landingPage=${encodeURIComponent(hotelsSearch)}&camref=${HOTELS.camref}&creativeref=${HOTELS.creativeref}&adref=${HOTELS.adref}`,
    expedia: `https://expedia.prf.hn/click/camref:${EXPEDIA_CAMREF}/pubref:event-page/destination:${encodeURIComponent(expediaSearch)}`,
  };
}

export default function StayNearVenueCard({ rawEvent, adults = 2 }) {
  const l = stayLinks(rawEvent, adults);
  if (!l) return null;
  const night = new Date(`${l.dates.checkIn}T12:00:00Z`).toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric", timeZone: "UTC" });
  return (
    <div className="bg-[#111827] rounded-2xl border border-[#1F2937] p-6">
      <div className="flex items-center gap-2 mb-2">
        <BedDouble className="w-5 h-5 text-red-500" />
        <h2 className="text-xl font-black uppercase tracking-tight text-white">Staying the night?</h2>
      </div>
      <p className="text-white/60 text-sm leading-relaxed mb-4">
        Hotels near {l.venue} for {night}, check-out the next morning. Dates are filled in; change them on the next page.
      </p>
      <div className="flex flex-col sm:flex-row gap-3">
        <a href={l.hotels} target="_blank" rel="noopener noreferrer sponsored"
          className="flex-1 inline-flex items-center justify-center gap-2 px-4 py-3 rounded-xl bg-[#D32735] hover:bg-[#B71F2B] text-white font-black text-sm uppercase tracking-wide transition-colors">
          Hotels near the venue · Hotels.com <ExternalLink className="w-4 h-4" />
        </a>
        <a href={l.expedia} target="_blank" rel="noopener noreferrer sponsored"
          className="flex-1 inline-flex items-center justify-center gap-2 px-4 py-3 rounded-xl border border-[#1F2937] bg-[#0F172A] hover:border-white/30 text-white font-bold text-sm transition-colors">
          Compare on Expedia <ExternalLink className="w-4 h-4" />
        </a>
      </div>
      <p className="text-white/35 text-[11px] mt-3">Partner links: InstaPass may earn a commission on bookings.</p>
    </div>
  );
}
